import React from 'react';
import { motion } from 'framer-motion';
export function PricingCards() {
  return <section id="pricing" className="py-16 px-4 bg-black border-t border-white/5" data-id="element-226">
      <div className="max-w-5xl mx-auto" data-id="element-227">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-12" data-id="element-228">
          ELEGÍ TU PACK
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-229">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="border-2 border-brand-green rounded-3xl p-8 shadow-[0_8px_30px_rgba(57,185,0,0.2)] flex flex-col bg-white/5 backdrop-blur-sm relative items-center" data-id="element-230">
            <div className="mb-6" data-id="element-231">
              <h3 className="text-2xl font-extrabold text-white mb-2 flex items-center justify-center gap-2" data-id="element-232">
                <span data-id="element-233">📘</span> MEGAPACK ANTI INFLAMACIÓN
              </h3>
              <p className="font-bold text-brand-green mb-4" data-id="element-234">
                6 Tomos + 6 Bonos
              </p>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-235">
                Ideal para quien quiere bajar la hinchazón, resetear el sistema
                digestivo y entender qué le inflama de una vez por todas.
              </p>
            </div>

            <div className="mb-8 mt-auto" data-id="element-236">
              <p className="text-gray-500 line-through text-lg font-bold mb-1" data-id="element-237">
                $65.000
              </p>
              <div className="flex items-baseline gap-2 justify-center" data-id="element-238">
                <span className="text-5xl font-extrabold text-white" data-id="element-239">
                  $19.990
                </span>
                <span className="text-xl font-bold text-gray-400" data-id="element-240">ARS</span>
              </div>
            </div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-brand-green text-white font-bold text-lg py-4 px-6 rounded-xl shadow-[0_8px_20px_rgba(57,185,0,0.4)] hover:shadow-[0_10px_30px_rgba(57,185,0,0.6)] transition-all" data-id="element-241">
              QUIERO MI MEGAPACK AHORA
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="border-4 border-brand-pink rounded-3xl p-8 shadow-[0_10px_40px_rgba(255,45,122,0.3)] flex flex-col bg-white/5 backdrop-blur-sm relative md:-translate-y-4 items-center" data-id="element-242">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand-pink text-white px-6 py-1.5 rounded-full font-bold text-sm shadow-md whitespace-nowrap" data-id="element-243">
              MÁS POPULAR
            </div>

            <div className="mb-6 mt-2" data-id="element-244">
              <h3 className="text-2xl font-extrabold text-white mb-2 flex items-center justify-center gap-2" data-id="element-245">
                <span data-id="element-246">🏆</span> MEGAPACK + EFECTO JEAN FLOJO ⭐
              </h3>
              <p className="font-bold text-brand-pink mb-4" data-id="element-247">
                6 Tomos + 6 Bonos + Sistema 30 Días
              </p>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-248">
                Ideal para quien no solo quiere el reseteo sino vivir
                deshinchada de forma permanente y que el jean flojo sea su nueva
                normalidad para siempre.
              </p>
            </div>

            <div className="mb-8 mt-auto" data-id="element-249">
              <p className="text-gray-500 line-through text-lg font-bold mb-1" data-id="element-250">
                $85.000
              </p>
              <div className="flex items-baseline gap-2 justify-center" data-id="element-251">
                <span className="text-5xl font-extrabold text-white" data-id="element-252">
                  $27.990
                </span>
                <span className="text-xl font-bold text-gray-400" data-id="element-253">ARS</span>
              </div>
            </div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-brand-pink text-white font-bold text-lg py-4 px-6 rounded-xl shadow-[0_8px_20px_rgba(255,45,122,0.4)] hover:shadow-[0_10px_30px_rgba(255,45,122,0.6)] transition-all" data-id="element-254">
              QUIERO EL COMBO COMPLETO
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>;
}